import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import VetsReportingShowTable from "./VetsReportingShowTable";
import { Backdrop, CircularProgress, FormControlLabel, Switch } from "@mui/material";

export default function VetsReporting({vet_id}) {

    const [selMonth, setSelMonth] = useState(new Date().toLocaleDateString('en-CA').slice(0,7));
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([]);
    const [dataFiltered,setDataFiltered] = useState([]);

    useEffect(() => {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/orders/redeemed/')+ vet_id,
            setData,
            loading,
            setLoading
        )
    },[loading, vet_id])

   

    useEffect(() => {
        let arr = [];
        for(let x in data) {
            let m = new Date(data[x]['transaction_date']).toLocaleDateString('en-CA').slice(0,7)
            if(!arr.includes(m)) arr.push(m);
        }
        setSelMonth(arr[0]);

    }, [data]);

    useEffect(() => {
        let arr = [];
        for(let x in data) {
            let m = new Date(data[x]['transaction_date']).toLocaleDateString('en-CA').slice(0,7)
            if(m === selMonth) {
                arr.push(data[x]);
            }
        }

        // disabled filtering
        setDataFiltered(data);

    },[selMonth,data]);

    //if(data.length === 0) return (<h3>Loading...</h3>);
    if(data.length === 0 && loading === true) return (<Backdrop open style={{ zIndex: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>);
    return (
        <div>            
            {/*<SelectMonth months={months} selMonth={selMonth} setSelMonth={setSelMonth} />*/}
            <VetsReportingShowTable data={dataFiltered} selMonth={selMonth} setLoading={setLoading} loading = {loading} />
        </div>
    )
}
